import type { SearchConfig } from '@/homescreen/search/omniSearch.types';
import { DEBOUNCE } from '@/core/core.constants';

export const DEFAULT_SEARCH_CONFIG: SearchConfig = {
  resultsPerPage: 10,
  debounce: DEBOUNCE.SHORT,
  minQueryLength: 0,
  highlightFormat: undefined,
  page: 1,
};

export const validateSearchConfig = (config: Partial<SearchConfig>): SearchConfig => {
  return {
    resultsPerPage: Math.max(1, Math.min(config.resultsPerPage ?? DEFAULT_SEARCH_CONFIG.resultsPerPage, 50)),
    debounce: config.debounce ?? DEFAULT_SEARCH_CONFIG.debounce,
    minQueryLength: Math.max(0, config.minQueryLength ?? DEFAULT_SEARCH_CONFIG.minQueryLength),
    highlightFormat: config.highlightFormat ?? DEFAULT_SEARCH_CONFIG.highlightFormat,
    page: Math.max(1, config.page ?? DEFAULT_SEARCH_CONFIG.page),
  };
};
